var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.599,
    height: 69.725,
    viewBox: "0 0 73.599 69.725",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#cd0f41;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M63.97,0H10.211A9.668,9.668,0,0,0,.291,9.4v50.93a9.663,9.663,0,0,0,9.913,9.4H36.719l.046-24.915H29.936a1.571,1.571,0,0,1-1.611-1.522l-.031-8.03A1.568,1.568,0,0,1,29.9,33.724h6.818V25.961c0-9.006,5.81-13.906,14.29-13.906h6.957a1.569,1.569,0,0,1,1.611,1.526v6.771a1.569,1.569,0,0,1-1.611,1.526H53.7c-4.61,0-5.5,2.08-5.5,5.125v6.721H58.333a1.559,1.559,0,0,1,1.6,1.7l-1.007,8.034a1.582,1.582,0,0,1-1.6,1.348H48.243L48.2,69.725H63.973a9.666,9.666,0,0,0,9.916-9.394V9.394A9.669,9.669,0,0,0,63.97,0Z",
    transform: "translate(-0.291)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace);
export default __webpack_public_path__ + "static/media/face.554794a0ed4013a122cf00164c5161c6.svg";
export { ForwardRef as ReactComponent };